import addAlpha from 'utils/add-alpha'
import colors from './colors'
import global from './global'

const { neutral, blue, red, green } = colors

const elevation = {
  elevationSmall: `0px 1px 4px ${addAlpha(neutral.black, 0.18)}`,
  elevationMedium: `0px 5px 16px ${addAlpha(neutral.black, 0.29)}`,
  elevationLarge: `0px 10px 30px ${addAlpha(neutral.black, 0.36)}`,
}

const darkTheme = {
  ...global,
  isDark: true,
  colorScheme: 'dark',
  colors: {
    ...colors,
    texts: {
      highEmphasis: addAlpha(neutral.white, 0.87),
      mediumEmphasis: addAlpha(neutral.white, 0.6),
      lowEmphasis: addAlpha(neutral.white, 0.38),
      textLink: blue.blue300,
      textSelected: blue.blue200,
      textInfo: blue.blue300,
      textDanger: red.red400,
      textSuccess: green.green300,
      highEmphasisInverse: addAlpha(neutral.black, 0.87),
      highEmphasisConstant: addAlpha(neutral.white, 0.87),
    },
    backgrounds: {
      backgroundPrimary: neutral.neutral900,
      backgroundSecondary: neutral.neutral800,
      backgroundElevated1: neutral.neutral800,
      backgroundElevated2: neutral.neutral700,
      backgroundPrimaryInverse: neutral.white,
      backgroundAccent: blue.blue400,
      backgroundAccentHover: blue.blue500,
      backgroundAccentActive: blue.blue600,
      backgroundDefaultHover: addAlpha(neutral.white, 0.05),
      backgroundDefaultActive: addAlpha(neutral.white, 0.08),
      backgroundDanger: red.red400,
      backgroundDangerHover: red.red500,
      backgroundDangerActive: red.red600,
      backgroundSelected: addAlpha(blue.blue300, 0.2),
      backgroundSelectedSecondary: addAlpha(blue.blue300, 0.2),
      backgroundOverlay: addAlpha(neutral.black, 0.4),
    },
    borders: {
      borderDefault: neutral.neutral600,
      borderAcent: blue.blue400,
      borderDanger: red.red400,
      borderSuccess: green.green400,
    },
  },
  shadows: {
    small: elevation.elevationSmall,
    medium: elevation.elevationMedium,
    large: elevation.elevationLarge,
  },
  borderWidth: {
    default: '1px',
  },
}

export default darkTheme
